import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPropertyByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  is_not_deleted: Types.Scalars['Boolean']['input'];
}>;


export type GetPropertyByIdQuery = { __typename?: 'query_root', properties_by_pk: Array<{ __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, premium?: boolean | null, tier_status?: string | null, workspace_id?: any | null, photo_link?: string | null, organization_id: any, warranty_expiration_date?: any | null, warranty_start_date?: any | null, warranty_document_id?: any | null, created_at?: any | null, updated_at?: any | null, partition_id?: string | null, building_type?: string | null, occupancy_class?: string | null, num_stories?: number | null, num_units?: number | null, construction_type?: string | null, sprinklered?: string | null, year_built?: number | null, expected_device_type?: any | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null, organization?: { __typename?: 'organizations', id: any, name: string, contact_name?: string | null, email?: string | null, type?: string | null } | null, property_contacts: Array<{ __typename?: 'property_contacts', id: any, name?: string | null, number?: string | null, email?: string | null }>, property_users: Array<{ __typename?: 'user_properties', user?: { __typename?: 'users', id: string, first_name: string, last_name: string, email: string, profile_photo?: string | null, phone_number?: string | null, role?: string | null, title?: string | null } | null }>, property_documents: Array<{ __typename?: 'property_documents', id: any, name?: string | null, photo_link?: string | null, document_link?: string | null, video_link?: string | null, audio_link?: string | null, site_link?: string | null, transcription?: string | null, transcribed?: boolean | null, type?: string | null, description?: string | null, doctrine_doc_id?: string | null, created_at?: any | null }>, installed_products: Array<{ __typename?: 'installed_products', id: any, product_id: any, property_id: any, installation_date: any, warranty_expiration_date?: any | null, warranty_status: string, product_serial?: string | null, location?: string | null, building_id?: any | null, floor_id?: any | null, room_id?: any | null, in_room_location?: any | null, building?: { __typename?: 'buildings', id: any, name: string } | null, floor?: { __typename?: 'floors', id: any, name: string } | null, room?: { __typename?: 'rooms', id: any, name: string } | null, product: { __typename?: 'products', id: any, name: string, description: string, sku?: string | null, make: string, model: string, photo_link?: string | null, product_category: { __typename?: 'product_categories', name: string, label: string } } }>, shop_products: Array<{ __typename?: 'shop_products', id: any, product_id: any, property_id: any, created_at: any, product?: { __typename?: 'products', id: any, name: string, description: string, sku?: string | null, make: string, model: string, organization_id?: any | null, workspace_id?: any | null, created_at?: any | null, retail_price?: any | null, extended_price?: any | null, photo_link?: string | null, parent_product_id?: any | null, product_category: { __typename?: 'product_categories', name: string, label: string }, parent_product?: { __typename?: 'products', id: any, name: string, make: string, model: string, description: string } | null } | null }>, buildings: Array<{ __typename?: 'buildings', id: any, name: string, sort_order: number, floors: Array<{ __typename?: 'floors', id: any, name: string, level_number?: number | null, sort_order: number, rooms: Array<{ __typename?: 'rooms', id: any, name: string, room_type?: string | null, is_inspectable: boolean, sort_order: number }> }> }> }> };


export const GetPropertyByIdDocument = gql`
    query getPropertyById($id: uuid!, $is_not_deleted: Boolean!) {
  properties_by_pk: properties(
    where: {id: {_eq: $id}, deleted_at: {_is_null: $is_not_deleted}}
  ) {
    id
    name
    address
    address_id
    standardized_address {
      id
      street_1
      street_2
      city
      state
      postal_code
      country
    }
    premium
    tier_status
    workspace_id
    photo_link
    organization_id
    warranty_expiration_date
    warranty_start_date
    warranty_document_id
    created_at
    updated_at
    partition_id
    building_type
    occupancy_class
    num_stories
    num_units
    construction_type
    sprinklered
    year_built
    expected_device_type
    organization_id
    organization {
      id
      name
      contact_name
      email
      type
    }
    property_contacts {
      id
      name
      number
      email
    }
    property_users(where: {user: {deleted_at: {_is_null: $is_not_deleted}}}) {
      user {
        id
        first_name
        last_name
        email
        profile_photo
        phone_number
        role
        title
      }
    }
    property_documents {
      id
      name
      photo_link
      document_link
      video_link
      audio_link
      site_link
      transcription
      transcribed
      type
      description
      doctrine_doc_id
      created_at
    }
    installed_products(where: {deleted_at: {_is_null: $is_not_deleted}}) {
      id
      product_id
      property_id
      installation_date
      warranty_expiration_date
      warranty_status
      product_serial
      location
      building_id
      floor_id
      room_id
      in_room_location
      building {
        id
        name
      }
      floor {
        id
        name
      }
      room {
        id
        name
      }
      product {
        id
        name
        description
        sku
        product_category {
          name
          label
        }
        make
        model
        photo_link
      }
    }
    shop_products {
      id
      product_id
      property_id
      created_at
      product {
        id
        name
        description
        sku
        product_category {
          name
          label
        }
        make
        model
        organization_id
        workspace_id
        created_at
        retail_price
        extended_price
        photo_link
        parent_product_id
        parent_product {
          id
          name
          make
          model
          description
        }
      }
    }
    buildings(order_by: {created_at: asc}) {
      id
      name
      sort_order
      floors(order_by: {created_at: asc}) {
        id
        name
        level_number
        sort_order
        rooms(order_by: {created_at: asc}) {
          id
          name
          room_type
          is_inspectable
          sort_order
        }
      }
    }
  }
}
    `;

/**
 * __useGetPropertyByIdQuery__
 *
 * To run a query within a React component, call `useGetPropertyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      is_not_deleted: // value for 'is_not_deleted'
 *   },
 * });
 */
export function useGetPropertyByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyByIdQuery, GetPropertyByIdQueryVariables> & ({ variables: GetPropertyByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyByIdQuery, GetPropertyByIdQueryVariables>(GetPropertyByIdDocument, options);
      }
export function useGetPropertyByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyByIdQuery, GetPropertyByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyByIdQuery, GetPropertyByIdQueryVariables>(GetPropertyByIdDocument, options);
        }
export function useGetPropertyByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyByIdQuery, GetPropertyByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyByIdQuery, GetPropertyByIdQueryVariables>(GetPropertyByIdDocument, options);
        }
export type GetPropertyByIdQueryHookResult = ReturnType<typeof useGetPropertyByIdQuery>;
export type GetPropertyByIdLazyQueryHookResult = ReturnType<typeof useGetPropertyByIdLazyQuery>;
export type GetPropertyByIdSuspenseQueryHookResult = ReturnType<typeof useGetPropertyByIdSuspenseQuery>;
export type GetPropertyByIdQueryResult = Apollo.QueryResult<GetPropertyByIdQuery, GetPropertyByIdQueryVariables>;